import { render } from "./TeacherMain.vue?vue&type=template&id=3c92fbd3&scoped=true&ts=true"
import script from "./TeacherMain.vue?vue&type=script&lang=ts"
export * from "./TeacherMain.vue?vue&type=script&lang=ts"

import "./TeacherMain.vue?vue&type=style&index=0&id=3c92fbd3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c92fbd3"]])

export default __exports__